<template>
  <v-app id="inspire">
    <v-content style="font-family:Microsoft JhengHei;">
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md6>
            <v-card class="elevation-12">
              <v-toolbar color="red" dark flat>
                <v-toolbar-title style="color:white;" v-if="typeFlag">通譯人員註冊</v-toolbar-title>
                <v-toolbar-title style="color:white;" v-if="!typeFlag">個人登入</v-toolbar-title>
                <v-spacer></v-spacer>

                <!-- <v-tooltip right>
                  <template v-slot:activator="{ on }">
                    <v-btn icon large target="_blank" v-on="on" @click="typeFlag = !typeFlag">
                      <v-icon>mdi-account</v-icon>
                    </v-btn>
                  </template>
                  <span>角色切換</span>
                </v-tooltip>-->
              </v-toolbar>
              <v-card-text>
                <v-form ref="form" v-model="valid">
                  <v-col cols="12" md="8">
                    <h2>帳號設定</h2>
                  </v-col>
                  <v-row dense>
                    <v-col cols="12" md="8">
                      <v-text-field
                        label="帳號"
                        type="text"
                        :rules="nameRules"
                        dense
                        counter
                        maxlength="20"
                        class="font-weight-normal"
                        v-model="member.account"
                        :error-messages="txtAccountExists"
                        v-on:change="checkAccount"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-text-field
                        id="password"
                        label="密碼"
                        :append-icon="showPassword1 ? 'visibility_off' : 'visibility'"
                        :type="showPassword1 ? 'text' : 'password'"
                        @click:append="showPassword1 = !showPassword1"
                        v-model="pw"
                        clearable
                        required
                        :rules="pwRules"
                        counter
                        maxlength="20"
                        dense
                        class="font-weight-normal"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-text-field
                        id="password2"
                        label="確認密碼"
                        :append-icon="showPassword2 ? 'visibility_off' : 'visibility'"
                        :type="showPassword2 ? 'text' : 'password'"
                        @click:append="showPassword2 = !showPassword2"
                        v-model="pw2"
                        clearable
                        required
                        :rules="pw2Rules"
                        counter
                        maxlength="20"
                        dense
                        class="font-weight-normal"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-label>
                        <p class="font-weight-normal">綁定社群帳號</p>
                      </v-label>
                      <v-spacer />
                      <v-btn class="mr-2" >Facebook 帳號</v-btn>
                      <v-btn class="mr-2" >Google 帳號</v-btn>
                    </v-col>
                    <v-col cols="12" md="8"></v-col>
                    <v-col cols="12" md="8"></v-col>
                  </v-row>
                  <v-col cols="12" md="8">
                    <h2>通譯人員基本資料</h2>
                  </v-col>
                  <v-row dense>
                    <v-col cols="12" md="8">
                      <v-text-field
                        label="姓名"
                        type="text"
                        :rules="requiredRules"
                        dense
                        class="font-weight-normal"
                        v-model="member.name"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-radio-group
                        v-model="member.gender"
                        label="性別"
                        dense
                        class="font-weight-normal"
                        :rules="requiredRules"
                      >
                        <v-radio label="男" value="M" dense color="red"></v-radio>
                        <v-radio label="女" value="F" dense color="red"></v-radio>
                      </v-radio-group>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-text-field
                        label="統一證號或身分證字號"
                        type="text"
                        :rules="requiredRules"
                        dense
                        class="font-weight-normal"
                        v-model="member.idNo"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-menu
                        v-model="menu1"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="member.birthday"
                            label="出生日期"
                            readonly
                            v-on="on"
                            dense
                            class="font-weight-normal"
                            :rules="requiredRules"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          :max="getDateFormat(new Date().getTime(), 'yyyy-MM-dd', true)"
                          v-model="member.birthday"
                          @input="menu1 = false"
                          locale="zh-cn"
                          style="font-family:Microsoft JhengHei;"
                          color="red"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-autocomplete
                        v-model="member.nationality"
                        :items="getCodeDateUtil('nation')"
                        label="原屬國籍"
                        dense
                        style="font-family:Microsoft JhengHei;"
                        class="font-weight-normal"
                        :rules="requiredRules"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-select
                        v-model="member.educationLevel"
                        :items="getCodeDateUtil('eduLevel')"
                        label="教育程度"
                        dense
                        class="font-weight-normal"
                        :rules="requiredRules"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-select
                        v-model="member.currentJob"
                        :items="getCodeDateUtil('jobType')"
                        label="現職"
                        dense
                        class="font-weight-normal"
                        :rules="requiredRules"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-radio-group
                        v-model="member.qualificationInTaiwan"
                        label="在臺資格與取得證件"
                        dense
                        class="font-weight-normal"
                        :rules="requiredRules"
                      >
                        <v-radio label="持中華民國身分證" value="持中華民國身分證" dense color="red"></v-radio>
                        <v-radio label="持有效之中華民國居留證" value="持有效之中華民國居留證" dense color="red"></v-radio>
                      </v-radio-group>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-select
                        :items="districtArray1"
                        item-text="name"
                        item-value="id"
                        v-model="member.city"
                        @change="districtObjectUtil(member.city);"
                        label="聯絡縣市"
                        dense
                        class="font-weight-normal"
                        :rules="requiredRules"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-select
                        :items="districtArray2"
                        item-text="name"
                        item-value="id"
                        label="聯絡地區"
                        dense
                        class="font-weight-normal"
                        v-model="member.district"
                        :rules="requiredRules"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-text-field
                        label="聯絡地址"
                        type="text"
                        :rules="requiredRules"
                        dense
                        class="font-weight-normal"
                        v-model="member.contactAddress"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4"></v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        id="contactHomeTel"
                        label="住家電話"
                        type="text"
                        :rules="contactHomeTelRules"
                        dense
                        class="font-weight-normal"
                        v-model="member.contactHomeTel"
                        @change="checkContactHomeTel"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        id="contactMobileTel"
                        label="行動電話"
                        type="text"
                        :rules="contactMobileTelRules"
                        dense
                        class="font-weight-normal"
                        v-model="member.contactMobileTel"
                        @change="checkContactMobileTel"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-text-field
                        label="電子信箱"
                        type="text"
                        :rules="emailRules"
                        dense
                        class="font-weight-normal"
                        v-model="member.email"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-textarea
                        label="個人註記及通譯服務經歷"
                        type="text"
                        clearable
                        dense
                        rows="3"
                        counter
                        maxlength="200"
                        class="font-weight-normal"
                        v-model="member.note"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <v-col cols="12" md="8">
                    <h2>通譯服務資訊</h2>
                  </v-col>
                  <v-row dense>
                    <v-col cols="12" md="8">
                      <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="member.serviceStartDate"
                            label="開始從事通譯服務時間"
                            readonly
                            v-on="on"
                            dense
                            class="font-weight-normal"
                            :rules="requiredRules"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          :max="getDateFormat(new Date().getTime(), 'yyyy-MM-dd', true)"
                          v-model="member.serviceStartDate"
                          @input="menu2 = false"
                          locale="zh-cn"
                          style="font-family:Microsoft JhengHei;"
                          color="red"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-autocomplete
                        item-color="red"
                        v-model="serviceType"
                        :items="getCodeDateUtil('serveType')"
                        dense
                        chips
                        small-chips
                        label="服務類型(可複選)"
                        multiple
                        class="font-weight-normal"
                        :rules="selectRequiredRules"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-autocomplete
                        item-color="red"
                        v-model="serviceLanguage"
                        :items="getCodeDateUtil('lang')"
                        dense
                        chips
                        small-chips
                        label="熟悉語言(可複選)"
                        multiple
                        class="font-weight-normal"
                        :rules="selectRequiredRules"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-label class="font-weight-normal">
                        <p class="font-weight-normal">可服務地區 (可複選)</p>
                      </v-label>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-btn
                        color="red"
                        dark
                        @click="dialogDistrict = !dialogDistrict;areaFlag = true"
                        class="font-weight-normal"
                      >增加地區</v-btn>
                    </v-col>
                    <v-col cols="12" md="10">
                      <div
                        v-show="selectItem.length==0 && areaFlag && !dialogDistrict"
                        class="v-text-field__details"
                      >
                        <div class="v-messages theme--light error--text" role="alert">
                          <div class="v-messages__wrapper">
                            <div class="v-messages__message">
                              <B>此欄位是必填</B>
                            </div>
                          </div>
                        </div>
                      </div>
                      <v-scroll-x-transition group hide-on-leave>
                        <v-chip
                          v-for="(selection, i) in selectItem"
                          :key="i"
                          color="grey"
                          dark
                          small
                          class="ma-1 font-weight-normal"
                        >
                          <v-icon left small @click="selectItem.splice(i,1)">mdi-window-close</v-icon>
                          {{ selection }}
                        </v-chip>
                      </v-scroll-x-transition>
                      <div v-if="dialogDistrict">
                        <v-dialog v-model="dialogDistrict" width="250px">
                          <DistrictComponents
                            :selectItem="selectItem"
                            v-on:childDialog="parentDialog"
                            v-on:update-text="getChildText"
                          ></DistrictComponents>
                        </v-dialog>
                      </div>
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-label>
                        <p class="font-weight-normal">
                          <br />可服務時間
                          (可複選)
                        </p>
                        <div
                          v-show="serviceTime.length==0 && serviceTimeFlag "
                          class="v-text-field__details"
                        >
                          <div class="v-messages theme--light error--text" role="alert">
                            <div class="v-messages__wrapper">
                              <div class="v-messages__message">
                                <B>此欄位是必填</B>
                              </div>
                            </div>
                          </div>
                        </div>
                      </v-label>
                    </v-col>
                    <v-col cols="12" md="12" sm="10">
                      <v-simple-table>
                      <thead>
                        <tr>
                        <th class="text-center"></th>
                        <th class="text-center"><v-label>早上 06:00-12:00</v-label></th>
                        <th class="text-center"><v-label>中午 12:00-18:00</v-label></th>
                        <th class="text-center"><v-label>晚上 18:00-24:00</v-label></th>
                        <th class="text-center"><v-label>午夜 00:00-06:00</v-label></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                        <td class="text-center">一</td>
                        <td><v-checkbox v-model="serviceTime" value="a1" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="a2" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="a3" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="a4" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        </tr>
                        <tr>
                        <td class="text-center">二</td>
                        <td><v-checkbox v-model="serviceTime" value="b1" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="b2" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="b3" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="b4" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        </tr>
                        <tr>
                        <td class="text-center">三</td>
                        <td><v-checkbox v-model="serviceTime" value="c1" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="c2" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="c3" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="c4" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        </tr>
                        <tr>
                        <td class="text-center">四</td>
                        <td><v-checkbox v-model="serviceTime" value="d1" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="d2" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="d3" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="d4" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        </tr>
                        <tr>
                        <td class="text-center">五</td>
                        <td><v-checkbox v-model="serviceTime" value="e1" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="e2" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="e3" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="e4" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        </tr>
                        <tr>
                        <td class="text-center">六</td>
                        <td><v-checkbox v-model="serviceTime" value="f1" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="f2" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="f3" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="f4" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        </tr>
                        <tr>
                        <td class="text-center">日</td>
                        <td><v-checkbox v-model="serviceTime" value="g1" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="g2" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="g3" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="g4" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        </tr>
                      </tbody>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-checkbox
                      v-model="readFlag"
                      hide-details
                      :rules="requiredRules"
                      class="font-weight-normal" >
                      <template v-slot:label>
                        <div @click.stop="">
                          本人已詳閱並同意<a href="javascript:;" @click.stop="terms = true">「內政部移民署個人資料蒐集告知聲明」</a>內容
                        </div>
                      </template>
                    </v-checkbox>
                    <v-dialog v-model="terms" width="70%">
                      <v-card>
                        <v-card-title class="red" dark>
                          <h2>
                            <font style="color:white">內政部移民署個人資料蒐集告知聲明</font>
                          </h2>
                        </v-card-title>
                        <v-card-text>
                          <div align='left'><br/><br/><ol>
                            <li>通譯人才資料庫(下稱本系統)係由內政部移民署(下稱本署)建置維護，供各級政府相關部會、機關團體及通譯人員使用。</li>
                            <li>您應於註冊時提供完整詳實且符合真實之個人資料，如有任何虛假或冒用他人名義登錄，應自負法律責任。若您所登錄之資料事後有變更，並應隨時於線上更新。若您提供之個人資料有填寫不實，或所登錄之資料已不符合真實而未更新，本署有權隨時停用您的帳號及使用各項服務之權利。</li>
                            <li>您有義務妥善保護自己的帳號及密碼，並於每次使用完本系統後確實登出，以防他人盜用。為維護您自身權益，請勿將帳號及密碼出借或轉讓他人使用。若您發現帳號或密碼遭人非法使用或有其他任何安全問題發生時，應立即通知本署。</li>
                            <li>本署謹依據中華民國《個人資料保護法》及施行細則等相關規定，蒐集、處理及利用您於本系統所提供之資料，已依法採取適當安全維護措施，以避免您個人資料遭到外洩、竊取、竄改或其他不當利用；然依據中華民國《個人資料保護法》第28條規定，您的個人資料及權利倘因天災、事變或其他不可抗力、第三方不法蒐集等因素而遭致損害，中華民國政府無法負損害賠償責任。</li>
                            <li>本署保留隨時修改本同意書規範之權利，修改後的規範將於本系統首頁公告，不另作個別通知。如果您不同意修改的內容，請勿繼續使用本服務。倘若您繼續使用本署提供之服務，則表示您同意並接受本同意書規範之任何修改。</li>
                          </ol></div>
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                  </v-row>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue"
                  style="color:white;"
                  v-if="!typeFlag"
                  @click="submitObject($event);"
                >Faccebook 登入</v-btn>
                <v-btn
                  color="black"
                  style="color:white;"
                  v-if="!typeFlag"
                  @click="submitObject($event);"
                >Google登入</v-btn>
                <v-btn color="grey lighten-3" style="color:black;" @click="reset();">清除</v-btn>
                <v-btn color="red" style="color:white;" :disabled="(!valid) || serviceTime.length==0 || selectItem.length==0" class="ma-2" @click="submitObject($event);">註冊</v-btn>
              </v-card-actions>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text href="javascript:history.go(-1);" >
                  <span class="mr-2" style="color:grey;font-size:12px;">回登入頁</span>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>
<script>
import swal from "sweetalert2";
import DistrictComponents from "../Common/DistrictComponents";
import { mapActions, mapGetters } from "vuex";
import Vue from "vue";
import codeDataUtil from "../../codeDataUtil.js";
Vue.use(codeDataUtil);

export default {
  components: {
    DistrictComponents
  },
  computed: {
    ...mapGetters({
      idbServerUrl: ["getIdbServerUrl"]
    })
  },
  watch: {
    serviceTime() {
      if (this.serviceTime.length != 0) this.serviceTimeFlag = true;
    }
  },

  data() {
    return {
      date: null,
      menu1: false,
      menu2: false,
      menu3: false,
      readFlag: false,
      terms: false,
      
      showPassword1: false,
      showPassword2: false,
      content: "<div align='left'><ol><li>通譯人才資料庫(下稱本系統)係由內政部移民署(下稱本署)建置維護，供各級政府相關部會、機關團體及通譯人員使用。</li>" + 
        "<li>您應於註冊時提供完整詳實且符合真實之個人資料，如有任何虛假或冒用他人名義登錄，應自負法律責任。若您所登錄之資料事後有變更，並應隨時於線上更新。若您提供之個人資料有填寫不實，或所登錄之資料已不符合真實而未更新，本署有權隨時停用您的帳號及使用各項服務之權利。</li>" + 
        "<li>您有義務妥善保護自己的帳號及密碼，並於每次使用完本系統後確實登出，以防他人盜用。為維護您自身權益，請勿將帳號及密碼出借或轉讓他人使用。若您發現帳號或密碼遭人非法使用或有其他任何安全問題發生時，應立即通知本署。</li>" + 
        "<li>本署謹依據中華民國《個人資料保護法》及施行細則等相關規定，蒐集、處理及利用您於本系統所提供之資料，已依法採取適當安全維護措施，以避免您個人資料遭到外洩、竊取、竄改或其他不當利用；然依據中華民國《個人資料保護法》第28條規定，您的個人資料及權利倘因天災、事變或其他不可抗力、第三方不法蒐集等因素而遭致損害，中華民國政府無法負損害賠償責任。</li>" +
        "<li>本署保留隨時修改本同意書規範之權利，修改後的規範將於本系統首頁公告，不另作個別通知。如果您不同意修改的內容，請勿繼續使用本服務。倘若您繼續使用本署提供之服務，則表示您同意並接受本同意書規範之任何修改。</li></ol></div>",

      ac: null,
      pw: null,
      pw2: null,
      row1: null,
      member: this.getModel("motorAccount"),
      selectOption: ["A", "B"],
      valid: true,
      accountExists: false,
      txtAccountExists: "",
      formHasErrors: false,
      nameRules: [
        // v => !!v || "Name is required",
        v => !!v || "此欄位是必填",
        v => (v && v.length >= 6) || "必須大於6",
        v => (v && v.length <= 21) || "不能大於20"
      ],
      pwRules: [
        //  特殊符號 (?=.*[^a-zA-Z0-9])
        v => !!v || "此欄位是必填",
        v => (v && v.length >= 6) || "必須大於6",
        v => (v && v.length <= 21) || "不能大於20",
        v => /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{6,}$/.test(v) || "密碼強度需 6 位數以上，並且至少包含大寫字母、小寫字母、數字各一"
      ],
      pw2Rules: [
        v => !!v || "此欄位是必填",
        v => (v && v.length >= 6) || "必須大於6",
        v => (v && v.length <= 21) || "不能大於20",
        v => /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{6,}$/.test(v) || "密碼強度需 6 位數以上，並且至少包含大寫字母、小寫字母、數字各一",
        v => v === this.pw || "和密碼不相符"
      ],
      requiredRules: [v => !!v || "此欄位是必填"],
      selectRequiredRules: [v => v.length != 0 || "此欄位是必填"],
      emailRules: [
        v => !!v || "此欄位是必填",
        v =>
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) || "電子信箱格式有誤!"
      ],
      contactHomeTelRules: [
        v =>
          (v && v.length > 0) ||
          this.member.contactMobileTel.length > 0 ||
          "住家電話或行動電話請二擇一選填"
      ],
      contactMobileTelRules: [
        v =>
          (v && v.length > 0) ||
          this.member.contactHomeTel.length > 0 ||
          "住家電話或行動電話請二擇一選填"
      ],

      typeFlag: true,
      dialogDistrict: false,
      testStr: null,
      districtArray1: this.getCodeDateUtil("district"),
      districtArray2: [],
      city: String,
      registerToken: null,
      serviceTime: [],
      selectItem: [],
      serviceType: [],
      serviceLanguage: [],
      areaFlag: false,
      serviceTimeFlag: false
    };
  },
  methods: {
    ...mapActions(["updateUser"]),

    parentDialog() {
      this.dialogDistrict = false;
    },
    checkContactHomeTel() {
      let vm = this;
      if (vm.member.contactMobileTel == "") {
        vm.member.contactMobileTel = " ";
        setTimeout(function() {
          vm.member.contactMobileTel = "";
        }, 100);
      }
    },
    checkContactMobileTel() {
      let vm = this;
      if (vm.member.contactHomeTel == "") {
        vm.member.contactHomeTel = " ";
        setTimeout(function() {
          vm.member.contactHomeTel = "";
        }, 100);
      }
    },
    getChildText: function(value) {
      this.selectItem = value;
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    
    checkAccount() {
      var vm = this;
      if (vm.member.account.length>5)
      vm.axios
        .get(
          vm.idbServerUrl +
            "idb/member/isAccountExist/" + vm.member.account,
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(function(response) {
          //console.log("response" + JSON.stringify(response.data));
          vm.accountExists=false;
          vm.txtAccountExists="";
          if (response.data.exist) {
            vm.accountExists=true;
            vm.txtAccountExists = "帳號重複，請重新設定";
          }
          console.log("accountExists  " + vm.accountExists);
        })
        .catch(function(error) {
          vm.handErrorUtil(error);
          //console.log(error);
        });
    },

    showMsg() {

      swal({
        title: "<h5>內政部移民署個人資料蒐集告知聲明</h5>",
        html: "<div align='left'><ol><li>通譯人才資料庫(下稱本系統)係由內政部移民署(下稱本署)建置維護，供各級政府相關部會、機關團體及通譯人員使用。</li>" + 
        "<li>您應於註冊時提供完整詳實且符合真實之個人資料，如有任何虛假或冒用他人名義登錄，應自負法律責任。若您所登錄之資料事後有變更，並應隨時於線上更新。若您提供之個人資料有填寫不實，或所登錄之資料已不符合真實而未更新，本署有權隨時停用您的帳號及使用各項服務之權利。</li>" + 
        "<li>您有義務妥善保護自己的帳號及密碼，並於每次使用完本系統後確實登出，以防他人盜用。為維護您自身權益，請勿將帳號及密碼出借或轉讓他人使用。若您發現帳號或密碼遭人非法使用或有其他任何安全問題發生時，應立即通知本署。</li>" + 
        "<li>本署謹依據中華民國《個人資料保護法》及施行細則等相關規定，蒐集、處理及利用您於本系統所提供之資料，已依法採取適當安全維護措施，以避免您個人資料遭到外洩、竊取、竄改或其他不當利用；然依據中華民國《個人資料保護法》第28條規定，您的個人資料及權利倘因天災、事變或其他不可抗力、第三方不法蒐集等因素而遭致損害，中華民國政府無法負損害賠償責任。</li>" +
        "<li>本署保留隨時修改本同意書規範之權利，修改後的規範將於本系統首頁公告，不另作個別通知。如果您不同意修改的內容，請勿繼續使用本服務。倘若您繼續使用本署提供之服務，則表示您同意並接受本同意書規範之任何修改。</li></ol></div>",
        padding: 40,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: true
      }).then(
          function () {},
          // handling the promise rejection
          function (dismiss) {
              if (dismiss === 'timer') {
                  console.log('I was closed by the timer')
              }
          }
      );
    },
    submitObject() {
      event.target.disabled = true;
      setTimeout(function() {
        // event.target.disabled = false;
      }, 5000);
      var vm = this;
      vm.member.password = vm.pw;
      vm.member.serviceCity = "";
      vm.member.serviceTime = "";
      vm.member.serviceType = "";
      vm.member.serviceLanguage = "";
      vm.member.lastLoginDate = Math.round(new Date());
      vm.member.status = "W";
      vm.member.type = "CCC";

      vm.selectItem.forEach(function(element) {
        if (vm.member.serviceCity.length != 0) vm.member.serviceCity += ",";
        vm.member.serviceCity += element;
      });

      vm.serviceTime.forEach(function(element) {
        if (vm.member.serviceTime.length != 0) vm.member.serviceTime += ",";
        vm.member.serviceTime += element;
      });

      vm.serviceType.forEach(function(element) {
        if (vm.member.serviceType.length != 0) vm.member.serviceType += ",";
        vm.member.serviceType += element;
      });

      vm.serviceLanguage.forEach(function(element) {
        if (vm.member.serviceLanguage.length != 0)
          vm.member.serviceLanguage += ",";
        vm.member.serviceLanguage += element;
      });

      //console.log("!!!!!!!!!! " + this.$refs.form.validate());
      //console.log("!!!!!!!!!! " + JSON.stringify(vm.member));

      vm.axios
        .get(vm.idbServerUrl + "idb/member/getRegisterToken", {})
        .then(function(response) {
          //console.log("register token " + response.data);
          vm.registerToken = response.data;
          var data = {
            registerToken: vm.registerToken,
            memberAccount: vm.member
          };

          vm.axios
            .post(vm.idbServerUrl + "idb/member/registerMemberAccount", data, {
              // headers: {
              //   "Content-Type": "application/json",
              //   Authorization: vm.$localStorage.get("idb_login_token")
              // }
            })
            .then(function(response) {
              console.log("response " + JSON.stringify(response));
              //vm.successSwalUtil();
              
              swal({
                title: "提醒您將「資格認證證書或培訓通過名冊」及「中華民國身分證或居留證件」電子檔，E-mail至移民署信箱QQ1085@immigration.gov.tw，以利審核開通權限。",
                allowOutsideClick: false,
                confirmButtonText: "確認",
                showConfirmButton: true
              });
              vm.reset();
              vm.$router.push({ path: "/Login" });
            })
            .catch(function(error) {
              vm.handErrorUtil(error);
              //console.log("!!!! " + error);
            });
        })
        .catch(function(error) {
          vm.handErrorUtil(error);
          //console.log(error);
        });
    }
  },
  mounted() {
    this.$refs.form.validate();
  }
};
</script>